/* eslint-disable @next/next/no-img-element */
import React from "react";

import styles from "./styles.module.scss";
import BulletPoint from "../../public/assets/icons/bullet-point.svg";

interface PointsProps {
  header?: string;
  points: string[];
  className?: string;
}

export default function Points({ header, points, className }: PointsProps) {
  return (
    <div className={`${styles.pointsSection} ${className}`}>
      {!!header && <h1 className={styles.pointsHeader}>{header}</h1>}

      <div className={styles.pointsHolder}>
        {points.map((point, index) => (
          <div key={index} className={styles.pointHolder}>
            <img className={styles.bulletPoint} src={BulletPoint.src} alt="bullet point" /> 
            <p className='text cooler-line'>{point}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
